import type { Page, SelectOptionDefault } from '../../types';

export const cpfClusters = {
  Synergy: ['DWP', 'DEFRA', 'MOJ', 'HO'],
  Matrix: ['DSIT', 'DESNZ', 'CO', 'DfE', 'HMT', 'DHSC', 'DCMS', 'AGO'],
  Defence: ['MOD Mil Pers'],
  Unity: ['HMRC', 'DfT', 'MHCLG'],
  Overseas: ['FCDO'],
};

export const clusterOptions: SelectOptionDefault[] = Object.entries(cpfClusters).map(
  ([cluster, departments]) => ({
    option: cluster,
    questions: [
      {
        questionType: 'select',
        name: `department-${cluster.toLowerCase()}`,
        title: 'Department',
        options: departments,
        hintOption: 'Select your department',
        rules: { required: true },
      },
    ],
  }),
);

const coverSheet: Page[] = [
  {
    pageType: 'information',
    name: 'before-you-start',
    title: 'Common Performance Framework quarterly return',
    description: `Provide monthly figures for your department within the selected financial quarter.

Enter 0 only when the measured value is zero. If a figure is unavailable, leave it blank and explain which month is missing and why in the Notes column alongside that metric.

The monthly metrics page lets you download all metric tables in one Excel workbook and upload the completed workbook. Keep sheet names, metric labels and column headings unchanged. Uploading replaces the figures and notes in those tables.

Quarter 1: April, May, June. Quarter 2: July, August, September. Quarter 3: October, November, December. Quarter 4: January, February, March.

This first version includes all 74 metrics from the supplied consolidation workbook for review. Recruitment and Qlik figures must be entered manually until those data sources are connected.

Treat completed returns and downloaded workbooks as Official-Sensitive.`,
  },
  {
    pageType: 'question',
    name: 'return-details',
    title: 'Department, reporting period and contact',
    questions: [
      {
        questionType: 'select',
        name: 'cluster',
        title: 'Cluster',
        options: clusterOptions,
        hintOption: 'Select your cluster',
        rules: { required: true },
      },
      {
        questionType: 'reportPeriod',
        name: 'report-period',
        title: 'Reporting period',
        defaultValue: 'auto-1',
        rules: { required: true },
      },
      {
        questionType: 'textInput',
        name: 'contact-name',
        title: 'Reporting lead full name',
        rules: { required: true },
      },
      {
        questionType: 'textInput',
        name: 'contact-email',
        title: 'Reporting lead email address',
        userEmail: true,
        hint: 'The submission confirmation is sent to the signed-in submitter.',
        rules: { required: true, email: true },
      },
    ],
  },
];

export default coverSheet;
